<template>
    <div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label>名称</label>
                </div>
                <div class="form-value width-2x">
                    <span>{{comnSvcRequire.title}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>服务类型</label>
                </div>
                <div class="form-value width-2x">
                    <span>{{comnSvcRequire.servcTypeName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>描述</label>
                </div>
                <div class="form-value width-2x">
                    <span>{{comnSvcRequire.desc || ''}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>允许抢单</label>
                </div>
                <div class="form-value width-2x">
                    <span v-if="comnSvcRequire.grabIssueAllowed">是</span>
                    <span v-else>否</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>创建人</label>
                </div>
                <div class="form-value width-2x">
                    <span>{{comnSvcRequire.creatorName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>创建时间</label>
                </div>
                <div class="form-value width-2x">
                    <span>{{comnSvcRequire.createTime}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import shopComnReqApi from '../../api/shopComnReq'

    export default {
        name: 'swb-comn-require-detail',
        desc: '常规服务需求-查看',
        props: ['id'],
        data: function () {
            return {
                comnSvcRequire: {}
            }
        },
        created: function () {
            if(!Utils.isNoB(this.id)) {
                this.getComnSvcRequireInfo();
            }
        },
        methods: {
            // 获取常规服务需求
            getComnSvcRequireInfo: function () {
                let self = this;
                let msgBoxDlg = MsgBox.loading();
                shopComnReqApi.getComnSvcRequireById(this.id, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        self.comnSvcRequire = Utils.merge({}, result.data);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/shopComnReq/ComnSvcRequireDetail.vue